import { useEffect, useState } from "react";
import { useSeo } from "@/hooks/useSeo";
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs";
import MapPicker from "@/components/map-picker";

export default function Contacts() {
  const [loaded, setLoaded] = useState(false);

  useSeo({
    title: "Контакты — Паруса на крыше | Адрес и телефон ресторана",
    description: "Контакты ресторана Паруса на крыше: Санкт-Петербург, ул. Марата, 5, 6 этаж. Телефон: +7 (812) 991-10-90. Работаем ежедневно с 12:00.",
    keywords: "контакты ресторан на крыше СПб, адрес Паруса на крыше, ул Марата 5 ресторан, телефон бронирование ресторан Петербург",
    image: "/photos/view_night.jpg",
    canonical: "/contacts",
  });
  useBreadcrumbs([{ name: "Контакты", path: "/contacts" }]);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100);
  }, []);

  return (
    <div className="w-full min-h-screen bg-background relative z-10 pt-[100px] md:pt-[120px] pb-32 overflow-x-hidden">
      {/* Background element */}
      <div className="fixed inset-0 z-0 pointer-events-none opacity-20">
        <img src="/photos/view_night.webp" alt="" className="w-full h-full object-cover" style={{ filter: "grayscale(100%) contrast(1.2)" }} loading="eager" fetchPriority="high" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom, #050D07, transparent, #050D07)" }} />
      </div>

      <div className="container mx-auto px-6 md:px-14 max-w-6xl relative z-10">
        <div className="hidden sm:block absolute top-0 right-0 font-serif text-[130px] md:text-[240px] font-light leading-none text-primary/5 select-none pointer-events-none tracking-tighter -mt-20">Связь</div>

        <div className="mb-14 md:mb-20" style={{ opacity: loaded ? 1 : 0, transform: loaded ? "translateY(0)" : "translateY(16px)", transition: "opacity 0.5s ease, transform 0.5s ease" }}>
          <h1 className="text-4xl md:text-7xl font-serif font-light text-primary mb-6 tracking-wide">Контакты</h1>
          <div className="w-24 h-[1px] bg-primary/30"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 mb-20" style={{ opacity: loaded ? 1 : 0, transform: loaded ? "translateY(0)" : "translateY(16px)", transition: "opacity 0.5s ease 0.1s, transform 0.5s ease 0.1s" }}>
          <div className="space-y-16">
            <div className="border-l border-primary/30 pl-8">
              <h3 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent mb-4 uppercase">Локация</h3>
              <p className="text-foreground font-light text-2xl mb-4 leading-relaxed font-serif">Санкт-Петербург,<br/>ул. Марата, 5, 6 этаж</p>
              <div className="flex flex-wrap gap-3 mt-2">
                <MapPicker
                  label="Открыть карту →"
                  className="text-[10px] tracking-[0.2em] uppercase text-primary"
                  dropUp={false}
                  align="left"
                />
              </div>
            </div>

            <div className="border-l border-primary/30 pl-8">
              <h3 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent mb-4 uppercase">Связь</h3>
              <div className="space-y-6">
                <div>
                  <p className="text-[9px] tracking-[0.2em] text-muted-foreground uppercase mb-2">Бронирование:</p>
                  <a href="tel:+78129911090" className="text-2xl text-foreground font-light tracking-wider hover:text-primary transition-colors font-serif">+7 (812) 991-10-90</a>
                </div>
                <div>
                  <p className="text-[9px] tracking-[0.2em] text-muted-foreground uppercase mb-2">Банкеты:</p>
                  <a href="tel:+78129225263" className="text-2xl text-foreground font-light tracking-wider hover:text-primary transition-colors font-serif">+7 (812) 922-52-63</a>
                </div>
                <div>
                  <p className="text-[9px] tracking-[0.2em] text-muted-foreground uppercase mb-2">Email:</p>
                  <a href="mailto:e@evdokimovgroup.ru" className="text-base text-foreground font-light hover:text-primary transition-colors">e@evdokimovgroup.ru</a>
                </div>
              </div>
            </div>

            <div className="border-l border-primary/30 pl-8">
              <h3 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent mb-4 uppercase">Режим</h3>
              <div className="grid grid-cols-[80px_1fr] gap-4 font-light text-sm text-foreground">
                <span className="text-muted-foreground">Пн–Чт</span> <span>12:00 — 23:00</span>
                <span className="text-muted-foreground">Пт–Сб</span> <span>12:00 — 01:00</span>
                <span className="text-muted-foreground">Вс</span> <span>12:00 — 23:00</span>
              </div>
            </div>

            <div className="border-l border-primary/30 pl-8">
              <h3 className="font-['Cormorant_SC'] text-lg tracking-[0.2em] text-accent mb-4 uppercase">Мы в сети</h3>
              <div className="flex flex-wrap gap-3 mb-6">
                <a href="https://vk.com/parusa_nakryshe" target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 border border-primary/25 px-4 py-2 text-[10px] tracking-[0.2em] uppercase text-muted-foreground hover:border-primary hover:text-primary transition-colors">
                  ВКонтакте →
                </a>
              </div>
              <div className="flex flex-wrap gap-3">
                <a href="https://yandex.ru/profile/228378467058?lang=ru" target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 border border-primary/25 px-4 py-2 text-[10px] tracking-[0.2em] uppercase text-muted-foreground hover:border-primary hover:text-primary transition-colors">
                  <span className="text-yellow-400">★</span> 5,0 Яндекс →
                </a>
                <a href="https://2gis.ru/spb/firm/70000001106091265" target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-2 border border-primary/25 px-4 py-2 text-[10px] tracking-[0.2em] uppercase text-muted-foreground hover:border-primary hover:text-primary transition-colors">
                  <span className="text-yellow-400">★</span> 4,9 2ГИС →
                </a>
              </div>
            </div>
          </div>

          <div className="h-[280px] md:h-[500px] w-full border border-primary/20 p-2 bg-card/80 backdrop-blur-sm">
            <iframe src="https://yandex.ru/map-widget/v1/?ll=30.354353%2C59.930232&z=17&pt=30.354353%2C59.930232,pm2rdl" width="100%" height="100%" frameBorder="0" allowFullScreen={true} title="Yandex Map" className="grayscale-[80%] contrast-[1.2] brightness-[0.7] opacity-80" />
          </div>
        </div>
      </div>
    </div>
  );
}
